<template>
  <div class="map-legend">
    <h3>{{ $t("provider.map.legend") }}</h3>
    <div class="legend-categories">
      <map-legend-item :key="category.name" :category="category" v-for="category in categories" />
    </div>
  </div>
</template>

<style scoped>

  .map-legend {
    border: 2px solid var(--primary-color);
    border-radius: 8px;
    padding: 16px;
    margin-top: -48px;
  }

  h3 {
    margin: 0 0 16px 0;
    color: var(--primary-color);
  }

  .legend-categories {
    display: flex;
    flex-wrap: wrap;
    color: var(--secondary-color);
    font-weight: 500;
  }
</style>

<script>
import MapLegendItem from './MapLegendItem.vue';

export default {
  name: 'map-legend',
  props: {
    categories: {
      type: Array,
      required: true,
    },
  },
  components: {
    MapLegendItem,
  },
};
</script>
